import watchRequested from './postWebToSalesforce';

export default [
  watchRequested(),
];
